import axios from 'axios'

import { AXIOS_TIMEOUT_ERROR } from '../constants/constants'

const BASE_URL = `/api/v1`

const HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

/**
 * @type {{
 *    user: UserEndpoint,
 * }}
 */

export let axiosInstance

function createApiInstance() {
  // if (apiInstance) {
  //   return apiInstance
  // }

  axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    timeoutErrorMessage: AXIOS_TIMEOUT_ERROR,
    headers: HEADERS
  })

  // const token = store.state.auth.token
  // if (token) {
  //   axiosInstance.defaults.headers.Authorization = `Bearer ${token}`
  // }
  return axiosInstance
}

export function getExistingApiInstance() {
  // if (!apiInstance) {
  //   return createApiInstance()
  // }
  return createApiInstance()
}
